module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-310x310-997ae3925c6c020d81c6bf93c11780ac.png";